import React from "react";
import { getIconUrl } from "../../../services/asset";
import { getWindowWidth, isMobileScreen } from "../../../services";

const ensureProtocol = (url: string) => {
  if (!url.startsWith('http://') && !url.startsWith('https://')) {
    return `https://${url}`;
  }
  return url;
};

const formatUrl = (url: string) =>
  url.replace(/^https?:\/\//, '').replace(/^www\./, '');

export const SocialMediaLinks = ({ seller, minified = false }) => {
  const isMobile = isMobileScreen(getWindowWidth());
  const shouldShowSocialMediaLinks = seller && (seller.websiteUrl || seller.facebookUrl || seller.instagramUrl)
  if (!shouldShowSocialMediaLinks) return null;

  const linkStyle: React.CSSProperties = {
    color: minified ? "#8C8C8C" : "#3F3F3F",
    display: "flex",
    alignItems: "center",
    maxWidth: "100%",
  };

  const textStyle: React.CSSProperties = {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  };

  return (
    <div style={{
      textAlign: "left",
      fontSize: minified ? 13 : 16,
      margin: minified ? "0 0 16px 2px" : "0 0 24px 0",
      overflow: "hidden",
      maxWidth: isMobile ? "100%" : 300
    }}
    >
      {seller.websiteUrl && (
        <div>
          <a target="_blank" href={ensureProtocol(seller.websiteUrl)} style={linkStyle}>
            <img src={getIconUrl("web.svg")} style={{ marginRight: minified ? 12 : 10, flexShrink: 0 }} />
            <span style={textStyle}>{formatUrl(seller.websiteUrl)}</span>
          </a>
        </div>
      )}
      {seller.facebookUrl && (
        <div>
          <a target="_blank" href={ensureProtocol(seller.facebookUrl)} style={linkStyle}>
            <img src={getIconUrl("facebook_red.svg")} style={{ marginRight: minified ? 12 : 10, flexShrink: 0 }} />
            <span style={textStyle}>{formatUrl(seller.facebookUrl)}</span>
          </a>
        </div>
      )}
      {seller.instagramUrl && (
        <div>
          <a target="_blank" href={ensureProtocol(seller.instagramUrl)} style={linkStyle}>
            <img src={getIconUrl("instagram_red.svg")} style={{ marginRight: minified ? 12 : 10, flexShrink: 0 }} />
            <span style={textStyle}>{formatUrl(seller.instagramUrl)}</span>
          </a>
        </div>
      )}
    </div>
  )
}




// WEBPACK FOOTER //
// ./src/containers/AdDetailsPage/SocialMediaLinks/SocialMediaLinks.tsx